import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PatentBasicService } from './services/patent-basic-service';
import { PatentBasicServiceImpl } from './services/impls/patent-basic-service';
import { PatentValuationService } from './services/patent-valuation-service';
import { PatentValuationServiceImpl } from './services/impls/patent-valuation-service';
import { GetBasicByIdDTO, GetValuationByIdDTO } from './services/patent-repository';
import { GetBasicByIdDTOImpl } from './repositories/impls/get-basic-by-id-repository';
import { GetValuationByIdDTOImpl } from './repositories/impls/get-valuation-by-id-repository';
import { GetPatentJpdcDTO } from './repositories/get-patent-jpdc';
import { GetPatentJpdcDTOImpl } from './repositories/impls/get-patent-jpdc';
import { GetPatentLinkDTO } from './repositories/get-patent-link';
import { GetPatentLinkDTOImpl } from './repositories/impls/get-patent-link';
import { GetPatentTransferDTO } from './repositories/get-patent-transfer';
import { GetPatentTransferDTOImpl } from './repositories/impls/get-patent-transfer';
import { GetPatentValuationDTO } from './repositories/get-patent-valuation';
import { GetPatentValuationDTOImpl } from './repositories/impls/get-patent-valuation';

export const patentModule = (bind: interfaces.Bind) => {
    bind(PatentBasicService).to(PatentBasicServiceImpl);
    bind(PatentValuationService).to(PatentValuationServiceImpl);
    bind(GetBasicByIdDTO).to(GetBasicByIdDTOImpl);
    bind(GetValuationByIdDTO).to(GetValuationByIdDTOImpl);
    bind(GetPatentJpdcDTO).to(GetPatentJpdcDTOImpl);
    bind(GetPatentLinkDTO).to(GetPatentLinkDTOImpl);
    bind(GetPatentTransferDTO).to(GetPatentTransferDTOImpl);
    bind(GetPatentValuationDTO).to(GetPatentValuationDTOImpl);
};
